import {BibLocalizacaoModel} from '@/models/biblioteca/biblocalizacao/biblocalizacao.model';
import api from '@/services/axios/api';
import {AxiosResponse} from 'axios';
import {DataSource, FiltrosModel} from '@/datasources/consulte-grid';
import TextoValor from '@/models/texto-valor';
import {RegisterOutput} from '@/models/register-output';
import router from '@/routes';
import { useStore } from '@/store';


class BibLocalizacaoService {
  dadosIndexPaginado(
    pagina: number,
    itensPorPagina: number,
    filters: FiltrosModel[],
    codigoEscola?: number
  ): Promise<AxiosResponse<DataSource<BibLocalizacaoModel>>> {
    return api.post<DataSource<BibLocalizacaoModel>>(
      `/BibLocalizacao/RetornoPaginado/${codigoEscola}`,
      {
        rowsPerPage: itensPorPagina,
        pageNumber: pagina,
        filters: filters,
      }
    );
  }

 inserirAtualizar(bibLocalizacao: BibLocalizacaoModel): Promise<AxiosResponse<RegisterOutput>> {
  const result = api.post('/BibLocalizacao', bibLocalizacao);
  return result;
 }

 remover(id: number): Promise<AxiosResponse> {
  return api.delete('/BibLocalizacao/' + id);
 }

 atualizar(bibLocalizacao: BibLocalizacaoModel): Promise<AxiosResponse> {
  return api.put('/BibLocalizacao', bibLocalizacao);
 }

 async get(id: number): Promise<BibLocalizacaoModel> {
  const result = await api.get<BibLocalizacaoModel>(`/BibLocalizacao/${id.toString()}`);
  return result.data;
 }
 async DropDownList() : Promise<TextoValor[]> {
  const routePath = router.currentRoute.value.path;
  const routeName = String(router.currentRoute.value.name || '');
  const isCentral =
   routePath.includes('/cadastroexemplar/0') ||
   routePath.includes('/biblioteca/bibexemplar/cadastro/0/') ||
   routeName === 'bibexemplar_grid_central' ||
   routeName === 'bibexemplar_create_central';
  const gesEscolaId = isCentral ? 0 : useStore().getters.getCodigoEscola;
  const endpoint = "/BibLocalizacao/DropDownList";
  const result = await api.get(endpoint, {
   params: {
    GesEscolaId: gesEscolaId,
   },
  });
  // Mapeando os dados para o formato TextoValor
  return result.data.map((item: any) => ({
   valor: item.valor,
   texto: item.texto,
   }));
 }

}
export default new BibLocalizacaoService();
